module.exports = __webpack_public_path__ + "static/img/temp-mobile-contents04@w.a2a1d8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezn-foundation/temp-mobile-contents04@w.jpg
// module id = zOBM
// module chunks = 0